import Button from 'core/display/buttons/Button'
import Image from 'core/display/Image'
import { signal } from 'services/SignalsService'

export default class NextHistoryButton {
  constructor(data) {
    this.self = new Button(data, new Image(data))

    this.createSignal()

    return this.self
  }

  createSignal(){
    const self = this

    signal.on('HISTORY:PAGE', (page) => {
      self.self.images[0].visible = page > 300
      self.self.images[1].visible = page < 300
    })
  }
}
